import { Module } from 'vuex'
import { mutations } from './mutations'
import { InitialState, InstallationState } from './types'
import { RootState } from '@/store/types';

const namespaced: boolean = true

export const installation: Module<InstallationState, RootState> = {
  namespaced,
  state: InitialState,
  mutations
}
